import {controlRangeInput} from "../../sources/js/functions/form-control";

(function() {
    const input_range = document.getElementById('inputRangeSumSelect');
    const input = document.getElementById('inputSumSelect');

    controlRangeInput(input_range, input);
})();
